import React from 'react'

function ListBookedTrips() {
    return (
        <div>ListBookedTrips</div>
    )
}

export default ListBookedTrips